import { setOidcVerifier, getOidcVerifier } from '~/utils/local-storage-utils/local-storage-utils';
import { useCryptographicallyRandom } from '~/domain/auth/hooks/use-cryptographically-random';
import { isValidCodeVerifier } from '~/domain/auth/utils/crypto';

const useAuthVerifier = () => {
  const storedVerifier = getOidcVerifier();
  const { randomString } = useCryptographicallyRandom();
  if (!isValidCodeVerifier(storedVerifier)) {
    setOidcVerifier(randomString);
    return { verifierCode: null };
  }
  return { verifierCode: storedVerifier };
};

export { useAuthVerifier };
